import request from "../Config/axios";
// -----------------------------------------------------------
export const GetById_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_ByFoodsAndParking_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/GetById_ByFoodsAndParking/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const OthersCompleted_Reserve_Api = async (reserveId) => {
    const { data } = await request.get(
        `/Reserve/OthersCompleted/?reserveId=${reserveId}`
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const SetReserveTimeFromSubPeriod_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/SetReserveTimeFromSubPeriod`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const SetReserveTime_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/SetReserveTime`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const SetReserveObjectInstance_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/SetReserveObjectInstance`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_ForUser_Paging_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/GetAll_ForUser_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_ForCurrentUser_Paging_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/GetAll_ForCurrentUser_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_ForPeriod_Api = async (periodId) => {
    const { data } = await request.get(
        `/Reserve/GetAll_ForPeriod?periodId=${periodId}`
    );
    return data;
};
// -----------------------------------------------------------
export const UpdatePrimaryUserInfo_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/UpdatePrimaryUserInfo`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const ConfirmReserveByUser_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/ConfirmReserveByUser/?id=${id}`
    );
    return data;
};

// -----------------------------------------------------------
export const ChangePriorityWithNext_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/ChangePriorityWithNext/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const AdvanceSearch_Paging_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/AdvanceSearch_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const ChangeReserveStatusByAdmin_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/ChangeReserveStatusByAdmin`,
        params
    );
    return data;
};


// -----------------------------------------------------------
export const GetAll_BetweenDate_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Reserve/GetAll_BetweenDate`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const SetPaymentByFish_Reserve_Api = async (params) => {
    console.log("params1", params);
    const { data } = await request.postMultiPart(
        `/Reserve/SetPaymentByFish`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const SetPaymentByFish_FoodAndParking_Reserve_Api = async (params) => {
    console.log("params1", params);
    const { data } = await request.postMultiPart(
        `/Reserve/SetPaymentByFish_FoodAndParking`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const OtherEnterCompleted_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/OtherEnterCompleted/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const TimeSelectCompleted_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/TimeSelectCompleted/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const BackToSelectOther_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/BackToSelectOther/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const ConfirmFilesByAdmin_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/ConfirmFilesByAdmin/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const ConfirmPaymentByAdmin_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/ConfirmPaymentByAdmin/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const ConfirmFoodAndParkingPaymentByAdmin_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/ConfirmFoodAndParkingPaymentByAdmin/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const AcceptByReception_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/AcceptByReception/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const CancelByAdmin_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/CancelByAdmin/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const CancelFoodAndParkingByAdmin_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/CancelFoodAndParkingByAdmin/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetReserveDays_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Reserve/GetReserveDays/?reserveId=${id}`
    );
    return data;
};
// -----------------------------------------------------------
